import * as React from "react";
import {Button} from "@progress/kendo-react-buttons";
import {useNavigate, useParams} from "react-router-dom";
import "animate.css";
import {Input} from "@progress/kendo-react-inputs";
import {Field, FieldWrapper, Form, FormElement} from "@progress/kendo-react-form";
import {emailValidator, passwordValidator} from "../../../helpers/Validators";
import {subscriptionUserAPI} from "../../../../../../utilities/api";
import {isNullOrEmptyString} from "@progress/kendo-data-query/dist/npm/utils";
import {useEffect} from "react";

export const LoginSteps = (props:any) => {
    let navigate = useNavigate();

    // TODO do we want to enable loading?
    const [loading, setLoading] = React.useState(false);

    const [error, setError] = React.useState<string>("");
    const [activateAccountSuccessMessage, setActivateAccountSuccessMessage] = React.useState<boolean>(false);
    const { activationToken } = useParams();

    const handleSubmit = async (dataItem: { [name: string]: any }) => {
        await subscriptionUserAPI.loginSubscriptionUser(dataItem.email, dataItem.password)
            .then( (response) => {
                const subUserInfo = response.data.output;

                localStorage.setItem("subscriptionUser", dataItem.email);
                localStorage.setItem("subscriptionToken", subUserInfo.loginToken);
                localStorage.setItem("subscriptionUserId", subUserInfo.subscriptionUserId);

                navigate("/subscriptionProfile");
            }).catch( (error) => {
                setError(error.response.data.message);
             });
    };

    useEffect( () => {
        const submitAccountActivation = async () => {
            const activationTokenString = activationToken ?? "";
            const subscriptionEmail = localStorage.getItem("subscriptionEmail") ?? "";

            await subscriptionUserAPI.activateAccount(subscriptionEmail, activationTokenString)
                .then( () => {
                    setActivateAccountSuccessMessage(true);
                }).catch( (error) => {
                    setError(error.response.data.message);
                });
        };


        if (props.activateAccount) {
            submitAccountActivation().catch(e => console.log(e));
        }
    }, [activationToken, props.activateAccount]);

    return (
        <Form
            onSubmit={handleSubmit}
            render={() => (
                <FormElement>

                    { !isNullOrEmptyString(error) &&<p style={{color: "red"}}>{error}</p>}

                    { activateAccountSuccessMessage &&<p>Your Account has been Successfully Activated. Please Login</p>}

                    <div style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                        <div style={{alignSelf: "center"}}>
                            <div style={{color: "#3271E7", width: "30vw"}}>

                                <FieldWrapper>
                                    <Field name={"email"} component={Input} labelclassname={"k-form-label"}
                                           label={"Email Address"} validator={emailValidator}/>
                                    <Field name={"password"} component={Input} labelclassname={"k-form-label"}
                                           label={"Password"} type={"password"} validator={passwordValidator}/>
                                </FieldWrapper>
                            </div>

                            <div style={{justifyContent: "space-between", alignContent: "center", marginTop: "20px"}}
                                className={"k-form-buttons k-button k-button-md k-rounded-md k-button-solid k-button-solid-bases-end"}>
                                <div>
                                    <Button themeColor={"primary"} style={{marginRight: "16px"}} disabled={false}
                                            type={"submit"}>
                                        Submit
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>

                </FormElement>
            )}
        />
    );
};
